const filteredBugsnagErrorMessages = [
  'globalThis',
  'ResizeObserver',
  'https://git.io/JUIaE#17'
];

export default filteredBugsnagErrorMessages;
